<template>
  <div class="pa-3">
    <h2>Cargo</h2>
    <p>
      Seair Seaplanes freight service is fast, easy, and reliable. We provide scheduled counter to counter service to
      Nanaimo, Vancouver Harbour, and Richmond (YVR) and counter to dock service from Richmond to the Southern Gulf
      Islands.
    </p>
    <p>We ship envelopes, packages, as well as, pets ranging in size and weight.</p>
    <p>
      <strong>Our freight rates for scheduled flights are as follows:</strong>
    </p>
    <ul>
      <li>Envelopes: $10.00 + 5% GST</li>
      <li>Parcels 1 to 20 lbs: $20.00 + 5% GST</li>
      <li>Parcels 21 to 30lbs: $30.00 + 5% GST</li>
      <li>Parcels over 30lbs: $30.00 + $1.00/lb + 5% GST</li>
    </ul>
    <p>
      <strong>
        The maximum dimensions for the cargo are based on the particular aircraft being used and are as
        follows:
      </strong>
    </p>
    <ul>
      <li>Cessna Caravan: 36″H X 36″W X 48″L</li>
      <li>All other Seair Aircraft: 14″H X 22″W X 30″L</li>
    </ul>
    <p>We will do our best to fit irregular shaped items. Please call our office for specifications.</p>
    <p>We can also fly cargo to any location in BC on a charter flight (charter rates apply)</p>
    <p>
      <strong>Our freight terms and conditions are as follows:</strong>
    </p>
    <ul>
      <li>Seair Seaplanes reserves the right to verify the contents of cargo presented for shipping.</li>
      <li>
        Third parties dropping off cargo are required to know the contents of all packages they are presenting to
        have shipped.
      </li>
      <li>Seair Seaplanes does not ship Dangerous Goods. If you are unsure about an item, please ask our staff.</li>
      <li>Seair Seaplanes reserves the right to deny the shipment of any cargo.</li>
      <li>Photo ID is required by the Consignee for pick-up of cargo.</li>
    </ul>
    <h2>Pet Policies</h2>
    <h3>DOGS:</h3>
    <p>
      <strong>20 POUNDS AND UNDER (ACCOMPANIED BY OWNER):</strong>
    </p>
    <p>
      Upon check-in, the dog will be weighed, and transported free of charge. The dog will sit on the owner’s lap
      with a dog harness (either supplied by the owner or by Seair Seaplanes), as well as, a Seair Seaplanes supplied
      seat belt attachment.
    </p>
    <p>
      <strong>21 POUNDS AND ABOVE (ACCOMPANIED BY OWNER):</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: "CargoPets"
}
</script>
